import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { money, miles } from "@/lib/format";
import { SampleBadge } from "@/components/common/ui";

export const ActiveListingCard = ({ listing: l, baseShort, onClose }) => (
  <div className="absolute bottom-4 left-4 z-20 w-[300px] animate-rise-in overflow-hidden rounded-md bg-white shadow-[0_24px_60px_-20px_rgba(0,0,0,0.6)]" data-testid="active-listing-card">
    <div className="relative h-36">
      <img src={l.photos?.[0]} alt={l.title} className="h-full w-full object-cover" />
      {l.sample && <SampleBadge className="absolute left-2 top-2" />}
      <button onClick={onClose} aria-label="Close" data-testid="active-listing-close" className="absolute right-2 top-2 grid h-8 w-8 place-items-center rounded-full bg-white/95">
        <X className="h-4 w-4" />
      </button>
    </div>
    <div className="p-4">
      <p className="text-xl font-medium">{money(l.price)}</p>
      <p className="text-[13px] text-ink">{l.beds} beds · {l.baths} baths · {l.sqft?.toLocaleString()} sqft</p>
      <p className="mt-1 truncate text-[13px] text-neutral-500">{l.neighborhood}, {l.city}</p>
      <p className="mt-2 text-[13px] font-medium text-brass-deep">
        {l.base_miles != null ? `${miles(l.base_miles)} to ${baseShort}` : `${miles(l.nearest_base?.miles)} to ${l.nearest_base?.short}`}
      </p>
      <Link to={`/listing/${l.listing_key}`} data-testid="active-listing-view" className="mt-3 flex h-10 items-center justify-center rounded-full bg-ink text-[14px] text-white hover:bg-neutral-800">
        View home
      </Link>
    </div>
  </div>
);
